import React, { createContext, useContext, useEffect, useState } from 'react'
import { useHistory } from '@fs/zion-router'

export const DirectedMessageContext = createContext()

const sendDirectedMessage = ({ socket, directedAction, destinationIds, data }) => {
  const destIds = destinationIds
  const m = {
    action: 'aDirectedMessage',
    data: {
      directedAction,
    },
    destinationIds: destIds,
  }

  if (data !== null && data !== undefined) {
    m.data = { ...data, ...m.data }
  }
  socket.send(JSON.stringify(m))
}

export default function useDirectedMessage(socket, directMessageTargetDeviceId) {
  const contx = useContext(DirectedMessageContext)

  if (directMessageTargetDeviceId) {
    contx.setDirectMessageTargetDeviceId(directMessageTargetDeviceId)
  }

  useEffect(() => {
    if (socket) {
      if (contx?.outgoingMessage) {
        if (socket?.readyState === 1) {
          sendDirectedMessage({
            socket,
            directedAction: contx.outgoingMessage.directedAction,
            data: contx.outgoingMessage.data,
            destinationIds: [contx.directMessageTargetDeviceId],
          })
          if (contx.outgoingMessage.clearAfterSet) {
            contx.setOutgoingMessage(null)
          }
        }
      }
    }
  }, [contx, socket])

  return contx
}

export function DirectedMessageProvider({ children }) {
  const [outgoingMessage, setOutgoingMessage] = useState({})
  const [incomingMessage, setIncomingMessage] = useState()
  const [directMessageTargetDeviceId, setDirectMessageTargetDeviceId] = useState()
  const history = useHistory()

  const respondToDirectedMessage = (payload) => {
    if (payload.data.directedAction === 'navigate') {
      if (history.location?.pathname !== payload.data.destination) {
        history.push(payload.data.destination)
      }
    } else {
      setIncomingMessage(payload)
    }
  }
  const clearLastIncomingMessage = () => {
    setIncomingMessage()
  }

  return (
    <DirectedMessageContext.Provider
      value={{
        respondToDirectedMessage,
        outgoingMessage,
        sendDirectedMessage: setOutgoingMessage,
        setOutgoingMessage,
        incomingMessage,
        sendDirectedMessageDetailed: sendDirectedMessage,
        clearLastIncomingMessage,
        directMessageTargetDeviceId,
        setDirectMessageTargetDeviceId,
      }}
    >
      {children}
    </DirectedMessageContext.Provider>
  )
}
